var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6452 21.9989C20.7846 22.8166 19.9252 23.4388 19.1919 23.0511L13.7004 20.1471C13.4079 19.9925 13.058 19.9925 12.7655 20.1471L7.27381 23.0508C6.54053 23.4385 5.6812 22.8164 5.82061 21.9987L6.87205 15.8321C6.92714 15.509 6.82039 15.1794 6.58634 14.95L2.12762 10.5788C1.537 9.99973 1.86463 8.99484 2.68304 8.8752L8.83492 7.97591C9.16106 7.92824 9.44277 7.7229 9.58799 7.427L12.3352 1.82924C12.7013 1.08333 13.7646 1.08335 14.1307 1.82926L16.8779 7.42743C17.0231 7.72334 17.3048 7.92869 17.631 7.97636L23.7827 8.87562C24.6011 8.99526 24.9287 10.0002 24.338 10.5792L19.8792 14.9499C19.6451 15.1794 19.5383 15.509 19.5934 15.8322L20.6452 21.9989Z",
    stroke: "#4E5865",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/starEmpty.15cb232ce1da745151c1ba2e1330229a.svg";
export { ForwardRef as ReactComponent };